import angular from 'angular';

module.exports = angular.module('common.components', [
  require('./human-schedules'),
  require('./live-demo-block'),
  require('./od-carousel'),
  require('./od-flip-dates'),
  require('./od-flip-dates-container'),
  require('./od-market-analysis-chart'),
  require('./od-properties-navigation-node'),
  require('./od-three-state-switch'),
  require('./od-document-preview'),
])
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/components/index.js
 **/